module.exports = __webpack_public_path__ + "media/images/cms/img_slide_06-28949d60f178852aa94128d05081f5b5.jpg";